import type { IControlProps } from 'components/controls/Field/Field.types'
import type { IColorPickerProps } from 'components/uiKit/ColorPicker'
import ColorPicker from 'components/uiKit/ColorPicker'

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldColorPicker: React.FC<IControlProps<IColorPickerProps<string | null>>> = ({
  name,
  onChange,
  ...rest
}) => {
  const handleOnChange = (value: string | null) => onChange({ name, value })
  return <ColorPicker {...rest} name={name} onChange={handleOnChange} />
}

export default FieldColorPicker
